(function () {
    'use strict';

    a3_cabin_reports.controller('FatigueCtrl', FatigueCtrl);

    function FatigueCtrl($scope, $routeParams, FlightFactory, $location, SafetyReportFactory, $timeout) {
        var flightId = $routeParams.flightId;
        var flight = FlightFactory.getFlightFromStorage(flightId);

        $scope.flight = flight;
        $scope.responseMessage = "";
        $scope.showPanel = "submit";

        $scope.operationalPhasesOptions = [
            'Parked', 
            'Pushback', 
            'Taxi-Out',
            'Take-Off',
            'Climb',
            'Cruise',
            'Descent',
            'Approach',
            'Landing', 
            'Taxi-In',
        ]

        $scope.rateFeltOptions = [
            'Fully Alert - wide awake',
            'Very Lively - responsive, but not at peak',
            'OK - somewhat fresh',
            'A Little Tired - less than fresh',
            'Moderately Tired - let down'
        ]

        $scope.signsPhysicalOptions = [
            'No physical signs noted ', 'Fidgeting', 'Rubbing eyes', 'Heavy eyelids', 'Yawning', 'Frequent blinking', 'Staring blankly', 
            'Long blinks', 'Difficulty keeping eyes open', 'Head nodding', 'Micro-sleeps', 'Unintentional sleeps'
        ]

        $scope.signsCognitiveOptions = [
            'No cognitive signs noted', 'Impaired attention', 'Difficulty concentrating', 'Impaired memory', 'Reduced communication', 'Impaired problem solving', 
            'Increased risk taking', 'Impaired situational awareness', 'Accidentally doing the wrong thing (error)', 'Accidentally not doing the right thing (omission)', 
            'Failure to anticipate the event or action'
        ]

        $scope.signsEmotionalOptions = [
            'No emotional signs', 'More quiet or withdrawn than usual', 'Lacking in energy', 'Lacking in motivation to do the task well', 'Negative mood', 
            'Irritable or grumpy behavior'
        ]

        $scope.counterMeasuresOptions = [
            'Controlled rest', 'Caffeine', 'Use of automationy', 'Change of controls', 'Turn up the lights', 
            'Food, drink', 'Increased checks', 'Workload share', 'Increased communication', 'Inform a colleague'
        ]

        $scope.hours24Options = Array.from({ length: 21 }, (_, i) => i); // Generates an array with values from 0 to 20

        $scope.hoursAwakeOptions = Array.from({ length: 21 }, (_, i) => i); // Generates an array with values from 0 to 20

        $scope.formData = {
            flightId: $routeParams.flightId,
            flightNo: flight.FlightNo,
            flightDate: flight.ScheduledDeparture,
            flightDep: flight.Departure,
            flightArr: flight.Arrival,
            flightRegistration: flight.AcTailNo,
            occurenceTitle: "",
            description: "",
            // attachedFiles: [],
            operationalPhase: "",
            rateFelt: "",
            signsPhysical: [],
            signsCognitive: [],
            signsEmotional: [],
            hours24: "",
            hoursAwake: "",
            rateFeltSecond: "",
            counterMeasures: []
        };

          $scope.toggleSelection = function(option, signs) {
            var idx = signs.indexOf(option);
            if (idx > -1) {
              signs.splice(idx, 1);
            } else {
              signs.push(option);
            }
          };
    
          $scope.isChecked = function(option, signs) {
            return signs.indexOf(option) > -1;
          };
          
          $scope.getSelectedOptionsText = function(signs) {
            if (signs.length === 0) {
              return "- Select options -";
            }
            return signs.join(', ');
          };

          $scope.isRequiredFieldEmpty = function(field) {
            return !field.length;
          };

        $scope.sizeLimitKb = 25000;
        $scope.fileTooLargeMsg = false;
        $scope.confirmCreateFatigueReport = confirmCreateFatigueReport;
        $scope.fileUploaded = fileUploaded;
        $scope.removeFile = removeFile;
        $scope.isIFileTooLarge = isFileTooLarge;
        $scope.submitFatigueReport = submitFatigueReport;
        $scope.sendFatigueReport = sendFatigueReport;
        $scope.submitted = false;


        function gotoFlightInfo(flightId) {
            $location.path('/flightinfo/' + flightId);
        }

        function submitFatigueReport() {
            if ($scope.fatigueReport.$valid) {
                confirmCreateFatigueReport();
            } else {
                bootbox.alert("Please fill in all the required fields.");
            }
        }

        function confirmCreateFatigueReport() {
            bootbox.dialog({
                message: "<strong>Would you like to proceed with the Fatigue Report?</strong><br/><br/>",
                title: "Send Report",
                buttons: {
                    confirm: {
                        label: 'Confirm',
                        className: "btn-success",
                        callback: function () {
                            $scope.showPanel = "loading";
                            SafetyReportFactory.saveFatigueReport($scope.formData)
                            .then(res => handleSubmitResponse(res));
                        }
                    },
                    cancel: {
                        label: "Cancel",
                        className: "btn-default",
                        callback: function () { }
                    }
                }
            })
        }
        
        function handleSubmitResponse(res) {
            var alertStyle = res.success ? "success" : "warning";
    
            bootbox.dialog({
                message: "<div class='alert alert-"+ alertStyle +"'><strong>" + res.message + " </strong></div>",
                title: "Response Message",
                buttons: {
                    cancel:{
                        label: "Close",
                        className: "btn-default",
                        callback: function(){
                            if (res.success) {
                                $timeout(gotoFlightInfo(flightId));
                            }
                            else {
                                $timeout($scope.showPanel = "submit");                           
                            }
                        }
                    }       
                }
            })            
        }
    
        function sendFatigueReport(formData) {
            $scope.submitted = true;
            if ($scope.fatigueReport.$valid && !$scope.isRequiredFieldEmpty(formData.signsPhysical) && !$scope.isRequiredFieldEmpty(formData.signsCognitive) && !$scope.isRequiredFieldEmpty(formData.signsEmotional)) {
                createFatigueReport();
            } else {
                bootbox.alert("Please fill in all the required fields.");
            }
        }
        function createFatigueReport() {
            bootbox.dialog({
                message: "<strong>Would you like to send the Fatigue Report?</strong><br/><br/>",
                title: "Send Report",
                buttons: {
                    confirm: {
                        label: 'Confirm',
                        className: "btn-success",
                        callback: function () {
                            $scope.showPanel = "loading";
                            SafetyReportFactory.emailFatigueReport($scope.formData)
                            .then(res => handleSubmitResponse(res));
                        }
                    },
                    cancel: {
                        label: "Cancel",
                        className: "btn-default",
                        callback: function () { }
                    }
                }
            })
        }
        
        function isFileTooLarge(image) {
            var isLarge= false;
            if (image && image.dataURL != null) {
                isLarge = (image.dataURL.length > $scope.sizeLimitKb * 1024);
            }
            return isLarge;
        }
        
        function fileUploaded(data) {
            var fileResult = data; //$scope.imageBrowsed;
            var uploadedFile = {};

            uploadedFile.fileBlobb = fileResult.dataURL;
            uploadedFile.description = fileResult.fileType || fileResult.file.type;
            uploadedFile.fileName = fileResult.fileName;

            // var files = $scope.formData.attachedFiles;
            if ($scope.formData.attachedFiles.length < 5) {
                // var n = Object.create(attachedFile);
                $scope.formData.attachedFiles.push(uploadedFile);

            } else {
                $scope.showMaxFiles = true;
            }
        }

        function removeFile(attachedFile) {
            var files = $scope.formData.attachedFiles;
            var arrayLenght = files.length;
            var itemIndex = -1;
            for (var i = 0; i < arrayLenght; i++) {
                if (files[i].fileName == attachedFile.fileName) {
                    itemIndex = i;
                    break;
                }
            }

            if (itemIndex >= 0) {
                files.splice(itemIndex, 1);

                return attachedFile;
            }
            if ($scope.showMaxImages) {
                appendPhoto();
            }
            $scope.showMaxImages = false;
        }

    }
})();